import { env } from "./utils/environmentAccessor";

const featureFlagEnabled = (flagName: string) => {
  return (env[`VITE_FEATURE_FLAG_ENABLE_${flagName}`] as string) === "true";
};

export const redirectConfig = {
  loginUrl: env.VITE_LOGIN_REDIRECT_URL as string,
};

export const applicationConfig = {
  clientId: env.VITE_APPLICATION_CLIENT_ID as string,
  apiPermissionScopes: (env.VITE_APPLICATION_PERMISSION_SCOPES as string).split(" "),
  language: env.VITE_APP_LANGUAGE as string,
  featureFlags: {
    enableTermsOfUse: featureFlagEnabled("TERMS_OF_USE"),
    enableDriveIndexRefresh: featureFlagEnabled("DRIVE_INDEX_REFRESH"),
    enableSPOFilterRead: featureFlagEnabled("SPO_FILTER_READ"),
    enableSPOFilterCreateOrUpdate: featureFlagEnabled("SPO_FILTER_CREATE_OR_UPDATE"),
    enableChatbotAnonymousMode: featureFlagEnabled("CHATBOT_ANONYMOUS_MODE"),
    enableChatbotSettings: featureFlagEnabled("CHATBOT_SETTINGS"),
    enableGlossary: featureFlagEnabled("GLOSSARY"),
    enableReportABug: featureFlagEnabled("REPORT_A_BUG"),
    enableStreamingChat: featureFlagEnabled("STREAMING_CHAT"),
    enableCancelledExchangePreview: featureFlagEnabled("CANCELLED_EXCHANGE_PREVIEW"),
  },
};

export const environementConfig = {
  isPipelineBuild: (env.VITE_ENV as string) === "production",
};

export const tenantConfig = {
  id: env.VITE_TENANT_ID as string,
};

const baseUrl = (env.VITE_API_BASEURL as string).replace(/\/+$/, "");
export const apiConfig = {
  baseUrl,
  url: `${baseUrl}/${env.VITE_API_SUFFIX as string}`,
};

export const appVersion = env.VITE_APP_VERSION as string;
